module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/customer-light.module.scss");